import { render, staticRenderFns } from "./EmailAlertConfig.vue?vue&type=template&id=525ace7c&scoped=true&"
import script from "./EmailAlertConfig.vue?vue&type=script&lang=js&"
export * from "./EmailAlertConfig.vue?vue&type=script&lang=js&"
import style0 from "./EmailAlertConfig.vue?vue&type=style&index=0&id=525ace7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ace7c",
  null
  
)

export default component.exports